import { render, staticRenderFns } from "./topHeaderBar.vue?vue&type=template&id=b2c5a368"
import script from "./topHeaderBar.vue?vue&type=script&lang=js"
export * from "./topHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./topHeaderBar.vue?vue&type=style&index=0&id=b2c5a368&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports